import { Injectable } from '@angular/core';
import { Segment } from 'src/app/models/Segment';
import { ProposalAttachmentApi } from 'src/app/core/http/entidades/ProposalAttachmentApi';

@Injectable({
  providedIn: 'root'
})
export class ProposalAttachmentService {

  constructor(private api: ProposalAttachmentApi) {
    this.api.baseName = 'proposalattachment';
   }
  /** buscar todas os segmentos */
  getall(): any {
    return new Promise((resolve, reject) => {
      this.api.get()
        .then(data => resolve(data))
        .catch(error => reject(error));
    });
  }
  /** buscar um segmento pelo Id */
  get(id: number): any {
    return new Promise((result, reject) => {
      this.api.getOne(id.toString())
        .then(data => result(data))
        .catch(error => reject(error));
    });
  }

  /** Salvar */
  save(obj: any): any {
    return new Promise((resolve, reject) => {
      // se segmento novo, insere
      if (obj.proposalAttachmentId === 0 || !obj.proposalAttachmentId) {
        this.api.post(obj)
          .then((data: Segment) => resolve(data))
          .catch(() => {
            reject();
          });
      } else { // senão atualiza
        this.api.put(obj)
          .then((data: Segment) => resolve(data))
          .catch(() => {
            reject();
          });
      }
    });
  }
  /** excluir */
  delete(id: number): any {
    return new Promise((resolve, reject) => {
      this.api.delete(id)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }

  getFromSegment(segmentId: number): any {
    return new Promise((result, reject) => {
      this.api.get('/fromsegment/' + segmentId.toString())
        .then(data => result(data))
        .catch(error => reject(error));
    });
  }

  getFromSubSegment(subSegmentId: number): any {
    return new Promise((result, reject) => {
      this.api.get('/fromsubsegment/' + subSegmentId.toString())
        .then(data => result(data))
        .catch(error => reject(error));
    });
  }
}
